import { useContext } from 'react';
import { Table, TableBody, TableCell, TableHead, TableRow, TableFooter, Typography, TablePagination, Grid } from '@material-ui/core';
import { TicketPrioritiesContext } from '../TicketPrioritiesContext';
import { DeleteIconButton, EditIconButton } from 'components';
import Moment from 'react-moment';


let Results = () => {
    let service = useContext(TicketPrioritiesContext);

    return (
        <Grid container>
            <Grid item xs>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Description</TableCell>
                            <TableCell>Color</TableCell>
                            <TableCell>Created on</TableCell>
                            <TableCell />
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {service.TicketPriorities.map((priority, index) =>
                            <TableRow hover key={index}>
                                <TableCell>{priority.description}</TableCell>
                                <TableCell>
                                    <div style={{ backgroundColor: priority.color, width: 100, height: 20 }} />
                                </TableCell>
                                <TableCell>
                                    <Moment date={priority.createdOn} format="LLL" />
                                </TableCell>
                                <TableCell align="right">
                                    <EditIconButton link={`/admin/ticketpriority/${priority.id}`} />
                                    <DeleteIconButton onClick={() => service.deleteTicketPriority(priority.id)} stopPropagation />
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                    {service.TicketPriorities.length === 0 &&
                        <TableFooter>
                            <TableRow>
                                <TableCell colSpan={4}>
                                    <Typography variant="subtitle2">No ticket priorities found</Typography>
                                </TableCell>
                            </TableRow>
                        </TableFooter>
                    }

                </Table>
                <TablePagination
                    rowsPerPageOptions={[service.search.pageSize]}
                    component="div"
                    count={service.recordCount}
                    rowsPerPage={service.search.pageSize}
                    page={service.search.pageNr}
                    backIconButtonProps={{ 'aria-label': 'Previous Page' }}
                    nextIconButtonProps={{ 'aria-label': 'Next Page' }}
                    onPageChange={(e, page) => service.changePage(page)}
                    labelDisplayedRows={({ page }) =>
                        <span>Found {service.recordCount} Ticket Priority&nbsp;&middot;&nbsp;page {page + 1} of {Math.ceil(service.recordCount / service.search.pageSize)}</span>
                    }
                />
            </Grid>
        </Grid>
    );
}

export default Results;